import React from 'react';
import { CommandBarButton, Stack } from '@fluentui/react';
import style from './ExportComponent.module.scss';
import PDFGeneratorService from '../../../services/PDFGeneratorService';

const ExportComponent: React.FC = () => {

  const exportHtmlElementToPdf = async (elementId: string) => {
     const pdfService = new PDFGeneratorService();
     await pdfService.exportHtmlToPDF(elementId);
  }

  return (
    <Stack.Item align='end'>
      <CommandBarButton text='Export chat' iconProps={{ iconName: 'PDF' }} onClick={() => exportHtmlElementToPdf('content')} className={style.exportButton} title='For best export results, set browser zoom to 100% or less' />
    </Stack.Item>
  );
};

export default ExportComponent;